// extracted by mini-css-extract-plugin
export default {"checkout-container":"Checkout_checkout-container__iAO31","btn":"Checkout_btn__vpdWJ"};